export default __webpack_public_path__ + "static/media/bg-cover3.75dbf28c.jpg";